module.exports = __webpack_public_path__ + "img/header-background-user-stat.e7bbf09e.png";